import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';

import { isMobile } from 'react-device-detect';
import {
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@material-ui/core';
import ReservationForm from './ReservationForm';
import AdminReservationForm from './AdminReservationForm';

const useStyles = makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const ReservationFormDialog = ({
  forAdmin, open, onClose, onSubmit, data,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  // const id = data ? data.id : '-1';
  // const hash = forAdmin ? `#admin_alert_${id}` : `#alert_${id}`;

  useEffect(() => {
    // if (open) {
    //   window.location.hash = hash;
    // }
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    if (typeof window !== 'undefined') {
      if (window.location.hash) {
        window.history.back();
      }
    }
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = () => {
    handleClose();
    if (onSubmit) onSubmit();
  };

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={isMobile}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
      >
        <AppBar
          className={classes.appBar}
          style={{ position: isMobile ? 'fixed' : 'inherit' }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {forAdmin ? '' : '온라인 상담 신청'}
            </Typography>
          </Toolbar>
        </AppBar>
        {isMobile ? <div className={classes.offset} /> : <></>}

        {forAdmin ? (
          <AdminReservationForm
            onSubmit={handleSubmit}
            editData={data}
            onClose={handleClose}
          />
        ) : (
          <ReservationForm onSubmit={handleSubmit} editData={data} isDialog />
        )}
      </Dialog>
    </>
  );
};
export default ReservationFormDialog;
